import styled from 'styled-components';

const StrongPaddingText = styled.strong`
  font-weight: bold;
  padding-right: 3px;
`;

export default StrongPaddingText;
